const getters = {
  token: (state) => state.user.token,
  userInfo: (state) => state.user.info,
  isIosMoveBack: (state) => state.app.isIosMoveBack,
  memberPopup: (state) => state.app.memberPopup,
  menuList: (state) => state.app.menuList,
  menuPath: (state) => state.app.menuPath,
  integralValue: (state) => state.user.integralValue,
  integralMoneyValue: (state) => state.user.integralMoneyValue
}
export default getters
